export default [
    {
        "name": "",
        "sort": 0,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 1,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 2,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 3,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 4,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 5,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 6,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 7,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 8,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 9,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 10,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 11,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 12,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 13,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 14,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 15,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 16,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 17,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 18,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 19,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "Entry Level Room Type",
        "sort": 20,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 21,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 22,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 23,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 24,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 25,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 26,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 27,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 28,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 29,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 30,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 31,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 32,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 33,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 34,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 35,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 36,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 37,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 38,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 39,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 40,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "Upscale Level Room Type",
        "sort": 41,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 42,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 43,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 44,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 45,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 46,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 47,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 48,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 49,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 50,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 51,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 52,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 53,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 54,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 55,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 56,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 57,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 58,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 59,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 60,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "",
        "sort": 61,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "Luxury Level Room Type",
        "sort": 62,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "Montly Grand Total",
        "sort": 63,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "Montly Grand Total(4.1.1)",
        "sort": 64,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "King Size Bed",
        "sort": 65,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "Twin Size Bed",
        "sort": 66,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    },
    {
        "name": "Montly Grand Total",
        "sort": 67,
        "inventory": 0,
        "ava": 0,
        "sold": 0,
        "occ": 0,
        "adr": 0,
        "rev": 0,
        "revp": 0
    }
]


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-1/4-1-4/data.js